import {
  Popover,
  PopoverSurface,
  PopoverTrigger,
  TableCellLayout,
} from "@fluentui/react-components";
import {
  CalendarIcon,
  DayIcon,
  DeleteIcon,
  EditIcon,
  MeatBallsMenuIconVertical,
  MiniCalendarSvg,
  MiniDayIcon,
} from "../../../../modules/default-svg";
import styles from "../ResourceMonitor.module.scss";
import { useContext, useState, useCallback, memo } from "react";
import Modal from "../../../../components/controls/modal/Modal";
import { ResourcePlannerContext } from "../ResourcePlannerContext";
import { tConverter } from "../../../../helpers/utils";

const ShiftCard = memo(({ handleEditShift, item }) => {
  const { deleteShift } = useContext(ResourcePlannerContext);
  const [shiftId, setShiftId] = useState(null);
  const [showDeleteModal, setShowDeleteModel] = useState(false);

  const handleDeleteShift = useCallback(async () => {
    await deleteShift(shiftId);
  }, [shiftId, deleteShift]);

  const ExampleContent = useCallback(({ item }) => {
    return (
      !showDeleteModal && (
        <div className="listingPopoverContent">
          <div
            className="popItem"
            onClick={() => {
              handleEditShift(item);
            }}
          >
            <EditIcon />
            <p className="text-sm-400 ms-12">Edit</p>
          </div>
          <div
            className="popItem"
            onClick={() => {
              setShowDeleteModel(true);
              setShiftId(item.id);
            }}
          >
            <DeleteIcon />
            <p className="text-sm-400 ms-12">Delete</p>
          </div>
        </div>
      )
    );
  }, [showDeleteModal, handleEditShift]);

  return (
    <div className={styles.shiftCardMain}>
      {showDeleteModal && (
        <Modal
          title={`Delete Shift`}
          body={
            <p className="text-sm-400 subHeading-color">{`Are you sure you want to delete the selected Shift?`}</p>
          }
          handleCancel={() => setShowDeleteModel(false)}
          handleSave={() => {
            setShowDeleteModel(false);
            handleDeleteShift();
          }}
          saveBtnLabel={`Delete`}
          cancelBtnLabel={"Cancel"}
          isLoading={false}
        />
      )}

      <div className="d-flex justify-content-between">
        <div className={styles.shiftCardHeader}>
          <h5 className="font-weight-500">{item.name}</h5>
          <span className="text-xsm-400 greyStrokeColor">
            {JSON.parse(localStorage.getItem("settings")).regionalSettings
              .timeFormat === "hh:mm"
              ? item.startTime
              : tConverter(item.startTime)}{" "}
            to{" "}
            {JSON.parse(localStorage.getItem("settings")).regionalSettings
              .timeFormat === "hh:mm"
              ? item.endTime
              : tConverter(item.endTime)}
          </span>
          <div className={styles.capacity}>
            Capacity
            <span className="text-xsm-600 calanderHeadercolor">
              {item.totalCapacity}hrs
            </span>
          </div>
        </div>
      </div>
      <div className="d-flex align-items-center gap-3">
        <div className="d-flex align-items-center gap-1">
          <MiniCalendarSvg />
          <span className="text-xsm-400 greyStrokeColor">
            {item?.startDate?.split("T")[0].split("-").join("/") ||
              "No Start Date"}{" "}
            -{" "}
            {item?.endDate?.split("T")[0].split("-").join("/") || "No End Date"}
          </span>
        </div>
        <div className="d-flex align-items-center gap-1">
          {item.daysOfWeek.length > 0 && <MiniDayIcon />}
          <span className="text-xsm-400 greyStrokeColor">
            {item.daysOfWeek.map((day, ind) => (
              <span key={day}>
                {day.substring(0, 3)}
                {ind !== item.daysOfWeek.length - 1 && ", "}
              </span>
            ))}
          </span>
        </div>
      </div>
    </div>
  );
});

ShiftCard.displayName = 'ShiftCard';

export default ShiftCard;
